import { useEffect, useRef, useState } from 'react';

import gsap from 'gsap';
import SplitText from 'gsap/SplitText';
import './About.css';

gsap.registerPlugin(SplitText);

const About = () => {
	const main = useRef();
	const [enter, setEnter] = useState(false);

	const anim = () => {
		let quote1 = document.querySelector('.first-line');
		let quote2 = document.querySelector('.second-line');
		let splitFirstLine = SplitText.create(quote1, { type: 'words' });
		let splitSecondLine = SplitText.create(quote2, { type: 'words' });

		gsap.from(splitFirstLine.words, {
			opacity: 0,
			y: 100,
			ease: 'back',
			duration: 1,
			stagger: 0.1,
		});
		gsap.fromTo(
			splitSecondLine.words,
			{
				opacity: 0,
				color: '#ff5f00',

				duration: 1,
				stagger: 0.1,
				scale: 4,
			},
			{
				opacity: 1,
				color: '#ff5f00',

				duration: 1,
				stagger: 0.1,
				scale: 1,
			}
		);
	};
	useEffect(() => {
		const ctx = gsap.context(() => {
			enter && anim();
		}, main);
		return () => {
			ctx.revert();
		};
	}, [enter]);
	return (
		<>
			<section
				onMouseEnter={() => {
					setEnter(true);
				}}
				className="about-me-container"
			>
				<div
					className="about-me-wrapper"
					ref={main}
				>
					<div className="about-title">
						<div>Hi!</div>
						<div>My name is Nicolas,</div>
					</div>
					<div className="about-me-content first-line">I'm a web devoloper, geoscientist & student forever ...</div>
					<div className="about-me-content second-line">Every day of my life is a new opportunity to learn something</div>
				</div>
				<div className="social-links">
					<div>
						<a
							href="https://www.linkedin.com/in/nicolas-g-a68b3846/"
							target="_blank"
							rel="noreferrer"
						>
							<ion-icon name="logo-linkedin"></ion-icon>
						</a>
					</div>
					<div>
						<a
							href="https://github.com/Nixoals"
							target="_blank"
							rel="noreferrer"
						>
							<ion-icon name="logo-github"></ion-icon>
						</a>
					</div>
					<div>
						<a href="mailto: nicolasgodeau1@gmail.com">
							<ion-icon name="mail-outline"></ion-icon>
						</a>
					</div>
				</div>
			</section>
		</>
	);
};

export default About;
